<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<p class="bkau"><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>Stefan Timmermans and Iddo Tavory</p>
<h1 class="bk">Data Analysis in Qualitative Research</h1>
<h1 class="bk1">Theorizing with Abductive Analysis</h1>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1"><span class="sm">CHICAGO</span> <span class="sm">&amp;</span> <span class="sm">LONDON</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-timmermans-0004.vue?6ad0c29e